import { enum__ComponentType, enum__ComponentType_InvertedEnum } from "../common/Dictionaries";
import { __OBJECT_STRUCTURE_BoardFilters } from "../common/ObjectStructures/sKPI";
import { 
	SET_PAGE_STATE,
	SET_ALL_NULL,
	SET_BOARD_COMPONENT_INFO_RECURSIVEVALUES,
	SET_BOARD_COMPONENT_INFO_FULL,
	SET_BOARD_CONTRACT_FILTER_COMPONENTS_AND_SYNC_FLAG,
	SET_BOARD_CONTRACT_FILTER_COMPONENTS,
	SET_BOARD_CONTRACT_FILTER_COMPONENTS_SYNC_FLAG,
	SET_BOARD_ELEMENT_ROLES
} from "./actions/KPI/actions";

const initialState = {
	_boardComponentInfoRecursiveFilled: false,
	_boardComponentInfoRecursiveValues: {
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_STADISTICS]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.SG3_HEADER]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_ROLES]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.CONTRACT_SERVICES_STATUS]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.CONTRACT_SERVICES]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.CONTRACT_KPI_COVERAGE]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.CONTRACT_LAST_EDP]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.SG3KPI_CONSOLIDATE_MONTH]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_BOOK_SUMMARY]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.OCR_CHART]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_SEGMENT]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_CATEGORY]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_PORTFOLIO_SUMMARY]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_KPI_DETAIL]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_FTE_CHART]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_AMOUNT]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_FTE_TREE]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_VARIABLE_DETAILS]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_BOOK_STATUS_SUMMARY]]: null,

		[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_TYPETEXT]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_COMMENT]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_CUSTOMTEXT]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_SIMPLE_KPI]]: null,

		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_SERVICE_SUMMARY]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_LIST_LAST_EDP]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EDP_COVER]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_LAST_EDP]]: null,


		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_LAST_MOVEMENTS]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_COMMENT_EVENT]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.OCR_CHART_GAUGE]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_OBLIGATIONS_CONTROL]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.PRODUCTS]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_FINANCIAL]]: null,


		
		[enum__ComponentType_InvertedEnum[enum__ComponentType.LIST]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.DS_SIMPLEDATA_PERFORMANCE]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.DS_SIMPLEDATA]]: null,

		[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_LIST_TO_COMPARE]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.CONSOLIDATE_GROUP_LIST_TO_SELECT]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_OPF]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_CHART]]: null,
		[enum__ComponentType_InvertedEnum[enum__ComponentType.CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE]]: null,
	},
	_boardContractFilterOfComponents: __OBJECT_STRUCTURE_BoardFilters(),
	_boardElementRoles: null,
	_systemRoles: null,
	_boardPageRedy: false
};

const boardViewComponentsReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_PAGE_STATE:
			return {
				...state,
				_boardPageRedy: action.payload,
			};
		case SET_ALL_NULL:
			return {
				...state,
				_boardComponentInfoRecursiveFilled: false,
				_boardComponentInfoRecursiveValues:  {
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_STADISTICS]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.SG3_HEADER]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_ROLES]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.CONTRACT_SERVICES_STATUS]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.CONTRACT_SERVICES]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.CONTRACT_KPI_COVERAGE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.CONTRACT_LAST_EDP]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.SG3KPI_CONSOLIDATE_MONTH]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_BOOK_SUMMARY]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.OCR_CHART]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_SEGMENT]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_CATEGORY]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_PORTFOLIO_SUMMARY]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_KPI_DETAIL]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_FTE_CHART]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_AMOUNT]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_FTE_TREE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_VARIABLE_DETAILS]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_BOOK_STATUS_SUMMARY]]: null,

					[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_TYPETEXT]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_COMMENT]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_CUSTOMTEXT]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_SIMPLE_KPI]]: null,

					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_SERVICE_SUMMARY]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_LIST_LAST_EDP]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EDP_COVER]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_LAST_EDP]]: null,

					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_LAST_MOVEMENTS]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_COMMENT_EVENT]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.OCR_CHART_GAUGE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_OBLIGATIONS_CONTROL]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.PRODUCTS]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.INFO_FINANCIAL]]: null,

					
					[enum__ComponentType_InvertedEnum[enum__ComponentType.LIST]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.DS_SIMPLEDATA_PERFORMANCE]]: null,




					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_LIST_TO_COMPARE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.CONSOLIDATE_GROUP_LIST_TO_SELECT]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_OPF]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_CHART]]: null,


					[enum__ComponentType_InvertedEnum[enum__ComponentType.CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EDP_RESUMEN]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EDP_DISTRIBUCION]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EDP_MONTOS_GRAPH]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_MOTNHS]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EDP_PARTIDAS_TBL]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_CONTRACT_LIST_BYROLE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_KPI_LIST_BYROLE]]: null,

					[enum__ComponentType_InvertedEnum[enum__ComponentType.OCR_CHART_LIST]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_CONTRACT_EXCHANGE_RATE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.POWERBI_COMPONENT_TABLE]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.POWERBI_COMPONENT_KEY_KPIS]]: null,
					[enum__ComponentType_InvertedEnum[enum__ComponentType.POWERBI_COMPONENT_OCR]]: null,
				},
			};
		case SET_BOARD_COMPONENT_INFO_RECURSIVEVALUES:
			return {
				...state,
				_boardComponentInfoRecursiveValues: {
				  	...state._boardComponentInfoRecursiveValues,
					[action.payload.componentTypeEnumName]: action.payload.data
				}
			};
		case SET_BOARD_COMPONENT_INFO_FULL:
			return {
				...state,
				_boardComponentInfoRecursiveFilled: action.payload.filled,
				_boardComponentInfoRecursiveValues:  action.payload.data
			};
		case SET_BOARD_CONTRACT_FILTER_COMPONENTS_AND_SYNC_FLAG: 
			return {
				...state,
				_boardContractFilterOfComponents: action.payload.filters,
				_boardComponentInfoRecursiveFilled: action.payload.flag
			};		
		case SET_BOARD_CONTRACT_FILTER_COMPONENTS: 
			return {
				...state,
				_boardContractFilterOfComponents: action.payload
			};
		case SET_BOARD_CONTRACT_FILTER_COMPONENTS_SYNC_FLAG: 
			return {
				...state,
				_boardComponentInfoRecursiveFilled: action.payload
			};
		case SET_BOARD_ELEMENT_ROLES: 
			return {
				...state,
				_boardElementRoles: action.payload.boardElementRoles,
				_systemRoles: action.payload.systemRoles
			};
		default:
			return state;
	}
};

export default boardViewComponentsReducer;